import { Controller } from "@hotwired/stimulus";
import { FontDirectUploader } from "@/utils/font_direct_uploader";

export default class extends Controller {
  static targets = ["dropZone", "fileInput", "imagesList", "cdnKeysContainer"];
  static values = {
    cdnHost: String,
    marketFontExtId: String,
    initialCdnKeys: Array
  }

  connect() {
    this.uploader = new FontDirectUploader(this.cdnHostValue);
    this.cdnKeys = this.initialCdnKeysValue || [];

    // Render initial hidden fields
    if (this.cdnKeys.length > 0) {
      this.updateCdnKeysField();
    }

    // Listen for sortable events
    this.element.addEventListener("font-upload--sortable:sorted", this.handleSort.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("font-upload--sortable:sorted", this.handleSort.bind(this));
  }


  updateCdnKeysField() {
    // Clear the container and re-render all hidden fields
    if (this.hasCdnKeysContainerTarget) {
      this.cdnKeysContainerTarget.innerHTML = '';

      // Create array fields for each cdn key
      this.cdnKeys.forEach(cdnKey => {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = 'font_listing[preview_image_cdn_keys][]';
        hiddenField.value = cdnKey;
        this.cdnKeysContainerTarget.appendChild(hiddenField);
      });
    }
  }

  handleFileSelect(event) {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      this.uploadFiles(files);
    }
  }

  handleDrop(event) {
    event.preventDefault();
    this.dropZoneTarget.classList.remove("border-blue-500", "bg-blue-50");

    const files = Array.from(event.dataTransfer.files).filter(file =>
      file.type.startsWith("image/")
    );

    if (files.length > 0) {
      this.uploadFiles(files);
    }
  }

  handleDragOver(event) {
    event.preventDefault();
    this.dropZoneTarget.classList.add("border-blue-500", "bg-blue-50");
  }

  handleDragLeave(event) {
    event.preventDefault();
    this.dropZoneTarget.classList.remove("border-blue-500", "bg-blue-50");
  }

  async uploadFiles(files) {
    try {
      const progressCallback = (current, total) => {
        console.log(`Uploading ${current} of ${total} files...`);
      };

      const results = await this.uploader.uploadPreviewImages(
        files,
        this.marketFontExtIdValue,
        progressCallback
      );

      results.forEach(result => {
        this.cdnKeys.push(result.cdnKey);
        this.addImageToList(result.cdnKey, result.url);
      });

      this.updateCdnKeysField();
      this.fileInputTarget.value = "";
    } catch (error) {
      console.error("Upload failed:", error);
      alert("이미지 업로드에 실패했습니다: " + error.message);
    }
  }

  addImageToList(cdnKey, url) {
    const imageHtml = `
      <div class="relative group cursor-move sortable-drag" data-cdn-key="${cdnKey}">
        <div class="relative w-[100px] h-[50px] overflow-hidden bg-gray-100 dark:bg-gray-800">
          <img src="${url || (this.cdnHostValue + "/" + cdnKey)}"
               class="absolute inset-0 w-full h-full object-cover">
        </div>
        <button type="button"
                class="absolute top-2 right-2 bg-red-500 text-white p-1 opacity-0 group-hover:opacity-100 transition-opacity"
                data-action="click->font-upload--font-preview-uploader#removeImage">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    `;

    this.imagesListTarget.insertAdjacentHTML("beforeend", imageHtml);
  }

  removeImage(event) {
    const imageDiv = event.currentTarget.closest("[data-cdn-key]");
    const cdnKey = imageDiv.dataset.cdnKey;

    // Remove from array
    const index = this.cdnKeys.indexOf(cdnKey);
    if (index > -1) {
      this.cdnKeys.splice(index, 1);
    }

    // Remove from DOM
    imageDiv.remove();

    // Update hidden field
    this.updateCdnKeysField();
  }

  handleSort(event) {
    // Get all image elements in their new order
    const imageElements = this.imagesListTarget.querySelectorAll("[data-cdn-key]");

    // Rebuild cdnKeys array based on new DOM order
    this.cdnKeys = Array.from(imageElements).map(el => el.dataset.cdnKey);

    // Update hidden field with new order
    this.updateCdnKeysField();
  }
}